<template>
  <van-popup
    v-model="kaiguan"
    round
    :style="{background:'transparent'}"
    @click-overlay="closeLogin"
  >
    <div class="tan">
      <p class="title">登录</p>
      <div class="input-box van-hairline--surround mb2">
        <div class="input-title">账号:</div>
        <div class="input-msg">
          <input type="text" placeholder="请输入您的雷电账号" v-model="name" />
        </div>
      </div>
      <div class="input-box van-hairline--surround mb4">
        <div class="input-title">密码:</div>
        <div class="input-msg">
          <input type="password" placeholder="请输入您的密码" v-model="password" />
        </div>
      </div>
      <button class="sumbit" @click.stop="login">确定</button>
    </div>
  </van-popup>
</template>

<script>
import qs from "qs";
import { Login } from "../config";
export default {
  name: "Login",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    name: "",
    password: ""
  }),
  computed: {
    kaiguan: {
      get: function() {
        return this.show === true;
      },
      set: function() {
        return;
      }
    }
  },
  methods: {
    closeLogin() {
      this.$emit("changelogin");
    },
    async login() {
      if (!this.name || !this.password) {
        this.$toast({
          type: "fail",
          message: "请填写完整的账号和密码",
          duration: 800
        });
        return;
      }

      let that = this;
      let encry = this.$jsencrypt;
      encry.setPublicKey(
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI6uOzpfsQ1ScFPt6QPBNYFLIxm/yJC4/7UtLcbZAYeB2Wz85mzaNnaQuKb4nkGC1ltcRKukztWRRKA+gVBOt5cCAwEAAQ=="
      );
      let db = {
        account: encry.encrypt(this.name),
        password: encry.encrypt(this.password)
      };
      try {
        let res = await this.$axios({
          withCredentials: true,
          crossDomain: true,
          method: "post",
          url: Login,
          transformRequest: [
            function(data) {
              // 对 data 进行任意转换处理
              return qs.stringify(data);
            }
          ],
          data: db
        });
        let { data } = res;
        if (data.code === -1) {
          this.$toast({
            type: "fail",
            message: "账号或密码错误,请重新输入",
            duration: 800
          });
          return;
        }
        this.$toast({
          type: "success",
          message: "登录成功",
          duration: 800,
          onClose() {
            that.$emit("getusername",data.data);
            that.$emit('changelogin')
          }
        });
      } catch (error) {
        this.$toast({
          type: "fail",
          message: error,
          duration: 800
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tan {
  background-color: #112b5d;
  color: #fff;
  padding: 40px 40px 45px 40px;
  width: 580px;
  box-sizing: border-box;
  .mb2 {
    margin-bottom: 20px;
  }
  .mb4 {
    margin-bottom: 40px;
  }
  .input-box {
    padding: 20px;
    display: flex;
    .input-title {
      font-size: 28px;
      color: #fff;
      width: 84px;
    }
    .input-msg {
      flex: 1;
      font-size: 28px;
      display: flex;
      align-items: center;
      input {
        color: #fff;
      }
      input::placeholder {
        color: #fff;
      }
    }
  }
  .title {
    font-size: 40px;
    text-align: center;
    margin-bottom: 40px;
  }
  .sumbit {
    cursor: pointer;
    width: 100%;
    border-radius: 10px;
    height: 80px;
    background-color: #00d5d4;
    color: #000;
  }
}
</style>
